<div class="badge-status" [class]="tipoStatus()" [style.border-radius]="badgeTotal ? '16px !important' : '16px 16px 0px 0px'" [style.width]="badgeWidth">
  <strong class="d-inline-mobile align-bottom text-truncate" [ngClass]="corTexto()">
    {{tipoTexto()}}
  </strong>
</div>
